var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.image,style:(_vm.pageBgStyles),attrs:{"id":"content"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.service.title)?_c('service',{attrs:{"service":_vm.service,"windowWidth":_vm.windowWidth}}):_c('div',{staticClass:"error"},[_vm._v("\n      Ошибка, данной услуги не существует\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43d2a585","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ServiceWrapper.vue
// module id = Wizd
// module chunks = 1